//@flow
import React from 'react';
import { QueryRenderer } from 'react-relay';
import { ProfileRootQuery } from './ProfileRootQuery';
import { Error } from '../shared';
import { logError } from '../helpers';
import { Loader } from './ProfileLoader';
import { DesignProfileWrapper } from './DesignProfileWrapper';
import { PAGE_TYPE_OVERVIEW, PAGE_TYPE_PROJECTS } from './constants';
import { Provider } from 'react-redux';

import type { PageType } from './constants';

type DesignProfileContainerProps = {
    adminHost: string,
    initialPage: PageType,
    firmUrlLabel: string,
    environment: any,
    isEditMode: boolean,
    isAdminMode: boolean,
    isTrade: boolean,
    store: mixed,
};

type QueryProps = {
    props: {
        viewer: any,
    },
    error?: any,
};

/* eslint-disable react/prop-types */
export const generateRenderProp = (outerProps: DesignProfileContainerProps) => ({
    props,
    error,
}: QueryProps) => {
    if (error) {
        // istanbul ignore next
        logError(error);
        return <Error />;
    } else if (props) {
        return (
            <DesignProfileWrapper
                adminHost={outerProps.adminHost}
                isClient
                isMobile={outerProps.isMobile}
                isTrade={outerProps.isTrade}
                isAdminMode={outerProps.isAdminMode}
                isEditMode={outerProps.isEditMode}
                viewer={props.viewer}
                initialPage={outerProps.initialPage}
                firmUrlLabel={outerProps.firmUrlLabel}
            />
        );
    }

    return <Loader />;
};

/* eslint-enable react/prop-types */

export function DesignProfileContainer(outerProps: DesignProfileContainerProps) {
    const { initialPage, firmUrlLabel, environment, isEditMode, store } = outerProps;
    // isTrade prop not used in query, needed to pass down to other components

    return (
        <Provider store={store}>
            <QueryRenderer
                fetchPolicy="store-or-network"
                environment={environment}
                query={ProfileRootQuery}
                variables={{
                    firmUrlLabel,
                    shouldRenderOverview: initialPage === PAGE_TYPE_OVERVIEW,
                    shouldRenderProjects: initialPage === PAGE_TYPE_PROJECTS,
                    isEditMode,
                }}
                render={generateRenderProp(outerProps)}
            />
        </Provider>
    );
}
